import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Home from "./Pages/Dashboard";
import Login from "./Pages/Login";
import { DataProvider } from "./DataProvider";

function Routing() {
  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem("UserID");

    if (userId) {
      navigate("/");
    } else {
      navigate("/login");

    }
  }, [navigate]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={
        <DataProvider>
          <Home />
        </DataProvider>
      } />
    </Routes>
  );
}

export default Routing;
